import { __spreadArray } from "tslib";
import classnames from 'classnames';
var bindOwnClassnamesWithSkin = function (ownClassMapping, skinClassMapping) {
    return function () {
        var classnamesList = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            classnamesList[_i] = arguments[_i];
        }
        var ownClassnames = classnamesList.map(function (classname) { return ownClassMapping[classname]; });
        var skinClassnames = classnamesList.map(function (classname) { return skinClassMapping[classname]; });
        return classnames.apply(void 0, __spreadArray(__spreadArray([], ownClassnames, false), skinClassnames, false));
    };
};
export default bindOwnClassnamesWithSkin;
//# sourceMappingURL=bindOwnClassnamesWithSkin.js.map